import { classEnum } from "./base";

export const AccountTypeEnum = new (class extends classEnum([
    {
        label: "Rekening Bank",
        value: "bank",
    },
    {
        label: "Kas Tunai",
        value: "cash",
    },
    {
        label: "Xendit",
        value: "xendit",
    },
]) {
    public get valuesCreate() {
        return this.values.filter((v) => v !== "xendit");
    }

    public get selectCreate() {
        return this.select.filter((v) => v.value !== "xendit");
    }

    public get ValuesCreate(): this["valuesCreate"][number] {
        throw new Error("ValuesCreate can't be used as a value");
    }
})();

export namespace AccountTypeEnum {
    export type Labels = (typeof AccountTypeEnum)["labels"][number];
    export type Values = (typeof AccountTypeEnum)["values"][number];
    export type ValuesCreate = (typeof AccountTypeEnum)["valuesCreate"][number];
}
